import APP_ROUTES, { APP_ROUTES_PATHS_WITH_PATH_PARAM } from './Routes';

export const HideTopNavBarRoutes = [
  APP_ROUTES.DASHBOARD.path,
  APP_ROUTES.APPROVALS.path,
  APP_ROUTES.LIVE_LOCATION_TRACKER.path,
  APP_ROUTES.PERFORMANCE_DASHBOARD.path,
  APP_ROUTES.REALLOCATION.path,
  APP_ROUTES.SENSEI.relativePath,
  APP_ROUTES.AGENT_AVAILABILITY.path,
  APP_ROUTES.AGENT_AVAILABILITY_HISTORY.path,
  APP_ROUTES.LEAVE_MANAGEMENT.path,
  APP_ROUTES.AGENCY_PINCODE_MAPPING.path,
  APP_ROUTES.WHATSAPP_CHATBOT.path,
  APP_ROUTES.SENSEI_TELE.path,
  APP_ROUTES.PARAMOUNT.path,
  APP_ROUTES.PARAMOUNT_PRODUCTS.path,
  APP_ROUTES.PARAMOUNT_TIMELINES.path,
  APP_ROUTES.PARAMOUNT_PLAYGROUND.path,
  APP_ROUTES.PARAMOUNT_SEGMENTS.path,
  APP_ROUTES.PARAMOUNT_VIEW_TIMELINE.path,
  APP_ROUTES.PARAMOUNT_EDIT_STRATEGY.path,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.daily_planning,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.overall_performance,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.field_governance,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.tele_governance,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_daily_planning,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.map_view_allocation,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.map_view_live_location,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_map_view_allocation,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_map_view_live_location,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_visit_plan,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.visit_plan,
  APP_ROUTES.AMEYO_UTILITY.path,
  APP_ROUTES.GENERATE_AMEYO_PASSWORD.path,
  APP_ROUTES.AMEYO_UPLOAD_NUMBERS.path,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.overall_metric,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.overall_metric_v2,
  APP_ROUTES.ALL_AGENTS.path,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_COORDINATION.tasks_for_me,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_COORDINATION.request_field_support,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.open,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.closed,
  APP_ROUTES.ALLOCATION.path,
  APP_ROUTES.ALLOCATE_CASES_FOR_AGENTS.path,
  APP_ROUTES.DEALLOCATE_CASES_FOR_AGENTS.path,
  APP_ROUTES.AGENTS_ALLOCATION.path,
  APP_ROUTES.AGENCY_ALLOCATION.path,
  APP_ROUTES.FIELD_ALLOCATIONS.path,
  APP_ROUTES.AGENCIES.path,
  APP_ROUTES.ALLOCATE_CASES_FOR_AGENCY.path,
  APP_ROUTES.DEALLOCATE_CASES_FOR_AGENCY.path,
  APP_ROUTES.CSA_DASHBOARD.path,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.dme,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.csa,
  APP_ROUTES.ENACH.path,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_capping,
  APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_pincode_mapping,
  APP_ROUTES.ALLOCATION_STATUS.path,
  APP_ROUTES.SYSTEM_ALLOCATION_STATUS.path,
  APP_ROUTES.REPORTS.path,
  APP_ROUTES.VIEW_REPORT_STATUS.path,
  APP_ROUTES.IMPERSONATION.path,
  APP_ROUTES.PREVIOUS_ALLOCATION.path,
  APP_ROUTES.ADDRESS_INGESTION.path,
  APP_ROUTES.WHATSAPP_CHATBOT_WITH_REFERENCE_ID.path,
  APP_ROUTES.CASE_EXCLUSION_EXPERIMENT.path,
  APP_ROUTES.CONFIGURE_REPORTS.path,
  APP_ROUTES.CIU_ALLOCATION.path,
  APP_ROUTES.CALL_AUDIT.path,
  APP_ROUTES.CALL_LIMIT.path
];

export const enableLonghornThemForPages = [
  APP_ROUTES.TEAM_LEAD_DASHBOARD.path,
  APP_ROUTES.CASES.path
];

const matchDynamicPath = (actualPath: string, routePath: string): boolean => {
  const actualParts = actualPath.split('/');
  const routeParts = routePath.split('/');

  if (actualParts.length !== routeParts.length) return false;

  return routeParts.every((routePart, index) => {
    if (routePart.startsWith(':')) return true;
    return routePart === actualParts[index];
  });
};

export const parseSubscriptionTopic = (
  subscriptionTopic: string
): { businessVertical: string; caseId: string } => {
  const topicParts = subscriptionTopic.split('|');
  return {
    businessVertical: topicParts[0] || '',
    caseId: topicParts[1] || ''
  };
};

export const returnScreenName = (pathName: string): string => {
  const pathWithoutQuery = pathName.split('?')[0];
  if (ScreeNameMapping[pathWithoutQuery]) {
    return ScreeNameMapping[pathWithoutQuery];
  }

  const matchingRoute = Object.entries(APP_ROUTES).find(([_, route]) => {
    if (!route.path) return false;
    return matchDynamicPath(pathWithoutQuery, route.path);
  });

  if (matchingRoute) {
    return ScreeNameMapping[matchingRoute[1].path] || 'unknown';
  }

  return 'unknown';
};

export const ScreeNameMapping: Record<string, string> = {
  [APP_ROUTES.CASES.path]: 'CASES',
  [APP_ROUTES.CASE_DETAIL.path]: 'CASE_DETAIL',
  [APP_ROUTES.HR_DASHBOARD.path]: 'HR_DASHBOARD',
  [APP_ROUTES.TL_GENERATE_AMEYO_PASSWORD.path]: 'TL_GENERATE_AMEYO_PASSWORD',
  [APP_ROUTES.DASHBOARD.path]: 'DASHBOARD',
  [APP_ROUTES.CSA_COORDINATION.path]: 'CSA_COORDINATION',
  [APP_ROUTES.ANOMALY_TRACKER.path]: 'ANOMALY_TRACKER',
  [APP_ROUTES.PERFORMANCE_DASHBOARD.path]: 'PERFORMANCE_DASHBOARD',
  [APP_ROUTES.TEAM_LEAD_DASHBOARD.path]: 'TEAM_LEAD_DASHBOARD',
  [APP_ROUTES.APPROVALS.path]: 'APPROVALS',
  [APP_ROUTES.LIVE_LOCATION_TRACKER.path]: 'LIVE_LOCATION_TRACKER',
  [APP_ROUTES.SENSEI_EXTERNAL.path]: 'SENSEI_EXTERNAL',
  [APP_ROUTES.CSA_DASHBOARD.path]: 'CSA_DASHBOARD',
  [APP_ROUTES.REALLOCATION.path]: 'REALLOCATION',
  [APP_ROUTES.SENSEI.path]: 'SENSEI',
  [APP_ROUTES.AGENT_AVAILABILITY.path]: 'AGENT_AVAILABILITY',
  [APP_ROUTES.AGENT_AVAILABILITY_HISTORY.path]: 'AGENT_AVAILABILITY_HISTORY',
  [APP_ROUTES.AGENCY_PINCODE_MAPPING.path]: 'AGENCY_PINCODE_MAPPING',
  [APP_ROUTES.AGENCY_CAPPING.path]: 'AGENCY_CAPPING',
  [APP_ROUTES.AGENCY_UTILITIES.path]: 'AGENCY_UTILITIES',
  [APP_ROUTES.AMEYO_UTILITY.path]: 'AMYO_UTILITY',
  [APP_ROUTES.GENERATE_AMEYO_PASSWORD.path]: 'GENERATE_AMEYO_PASSWORD',
  [APP_ROUTES.AMEYO_UPLOAD_NUMBERS.path]: 'AMEYO_UPLOAD_NUMBERS',
  [APP_ROUTES.LEAVE_MANAGEMENT.path]: 'LEAVE_MANAGEMENT',
  [APP_ROUTES.WHATSAPP_CHATBOT.path]: 'WHATSAPP_CHATBOT',
  [APP_ROUTES.SENSEI_TELE.path]: 'SENSEI_TELE',
  [APP_ROUTES.NOT_FOUND.path]: 'NOT_FOUND',
  [APP_ROUTES.TL_GENERATE_AMEYO_PASSWORD.path]: 'GENERATE_AMEYO_PASSWORD_TL',
  [APP_ROUTES.ALL_AGENTS.path]: 'ALL_AGENTS',
  [APP_ROUTES.ALLOCATION.path]: 'ALLOCATION',
  [APP_ROUTES.AGENTS_ALLOCATION.path]: 'AGENTS_ALLOCATION',
  [APP_ROUTES.AGENCY_ALLOCATION.path]: 'AGENCY_ALLOCATION',
  [APP_ROUTES.FIELD_ALLOCATIONS.path]: 'FIELD_ALLOCATIONS',
  [APP_ROUTES.ALLOCATE_CASES_FOR_AGENCY.path]: 'ALLOCATE_CASES_FOR_AGENCY',
  [APP_ROUTES.DEALLOCATE_CASES_FOR_AGENCY.path]: 'DEALLOCATE_CASES_FOR_AGENCY',
  [APP_ROUTES.ALLOCATE_CASES_FOR_AGENTS.path]: 'ALLOCATE_CASES_FOR_AGENTS',
  [APP_ROUTES.DEALLOCATE_CASES_FOR_AGENTS.path]: 'DEALLOCATE_CASES_FOR_AGENTS',
  [APP_ROUTES.PARAMOUNT.path]: 'PARAMOUNT',
  [APP_ROUTES.PARAMOUNT_EDIT_STRATEGY.path]: 'PARAMOUNT_EDIT_STRATEGY',
  [APP_ROUTES.PARAMOUNT_VIEW_STRATEGY.path]: 'PARAMOUNT_VIEW_STRATEGY',
  [APP_ROUTES.PARAMOUNT_PRODUCTS.path]: 'PARAMOUNT_PRODUCTS',
  [APP_ROUTES.PARAMOUNT_TIMELINES.path]: 'PARAMOUNT_TIMELINES',
  [APP_ROUTES.PARAMOUNT_VIEW_TIMELINE.path]: 'PARAMOUNT_VIEW_TIMELINE',
  [APP_ROUTES.PARAMOUNT_PLAYGROUND.path]: 'PARAMOUNT_PLAYGROUND',
  [APP_ROUTES.PARAMOUNT_SEGMENTS.path]: 'PARAMOUNT_SEGMENTS',
  [APP_ROUTES.ENACH.path]: 'ENACH',
  [APP_ROUTES.AGENCIES.path]: 'AGENCIES',
  [APP_ROUTES.SELF_SERVE_STATE_RESETTER.path]: 'SELF_SERVE_STATE_RESETTER'
};
